import { useCallback, useEffect, useState } from 'react';
import { draftsApi } from '../lib/api';
import type { DraftListItem } from '@shared/types';

export function useDraftList() {
  const [drafts, setDrafts] = useState<DraftListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setErr(null);
    try {
      const { drafts } = await draftsApi.list();
      setDrafts(drafts);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Failed to load drafts');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh]);

  return { drafts, loading, err, refresh };
}
